import { createFileRoute, useRouterState } from "@tanstack/react-router";
import z from "zod";

import { AuthRoutePage } from "@/features/auth/auth-route-page";

const authSearchSchema = z.object({
  r: z.string().optional().catch(undefined),
  error: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/auth")({
  component: RouteComponent,
  validateSearch: authSearchSchema.parse,
  head: () => ({
    meta: [{ name: "robots", content: "noindex,nofollow" }],
  }),
});

function RouteComponent() {
  const { r: referralCode, error } = Route.useSearch();
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  return (
    <AuthRoutePage
      isAuthIndex={pathname === "/auth" || pathname === "/auth/"}
      error={error}
      referralCode={referralCode}
    />
  );
}
